import { render, staticRenderFns } from "./AssessmentInformation.vue?vue&type=template&id=70b2a0c8"
import script from "./AssessmentInformation.vue?vue&type=script&lang=js"
export * from "./AssessmentInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports